module.exports = __webpack_public_path__ + "static/media/about-bg-left.c83dc045.jpg";